import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.cutomerName
var orderName = global.orderName
var crmServer = global.crmServer
var contractName = global.contractName
var payServer = global.payServer
var crmServer3 = global.crmServer3
// 车队长列表
// export const getAllCDZUser = p => post(`${crmServer}/tenant/getAllCDZUser`, p)
export let getAllCDZUser = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sTenant/getAllCDZUser`, p)
  } else {
    return post(`/${crmServer}/tenant/getAllCDZUser`, p)
  }
}
// 货主指派车队列表
// export const getAllTenantFleet = p => post(`${crmServer}/tenant/getAllTenantFleet`, p)
export let getAllTenantFleet = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sTenant/getAllTenantFleet`, p)
  } else {
    return post(`/${crmServer}/tenant/getAllTenantFleet`, p)
  }
}
// 车队列表
// export const getAllTenantDataBySomeData = p => post(`${crmServer}/tenant/getAllTenantDataBySomeData`, p)
export let getAllTenantDataBySomeData = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    if (p) {
      if (p.sysModel) {
        p.businessCodes = '000009'
        delete p.sysModel
      }
    }

    return post(`${crmServer3}/sTenant/selectTenantList`, p)
  } else {
    return post(`/${crmServer}/tenant/getAllTenantDataBySomeData`, p)
  }
}
// 根据租户名字查组合
export const selectTenantListByName = p => post(`${crmServer3}/sTenant/selectTenantListByName`, p)
// 货源管理查询
export const KCBlist = p => post(`/${name}/kCustomerBill/list`, p)
// 货源详情
export const SBLdetail = p => post(`/${name}/sBill/detail`, p)
// 合作公司查询
export const KCClist = p => post(`/${name}/kCooperationCompany/list`, p)
// 转为长期
export const KCCupdate = p => post(`/${name}/kCooperationCompany/update`, p)
// 合作公司删除
export const KCCdelete = p => post(`/${name}/kCooperationCompany/delete`, p)
// 获取货物类型
export const dropDownList = p => post(`/${orderName}/cProductType/dropDownList`, p)
// 添加货物
export const SBPadd = p => post(`/${name}/sBillWayProduct/add`, p)
// 获取货物
export const SBPlist = p => post(`/${name}/sBillWayProduct/list`, p)
// 编辑货物
export const SBPupdate = p => post(`/${name}/sBillWayProduct/update`, p)
// 删除货物
export const SBPdelete = p => post(`/${name}/sBillWayProduct/delete`, p)
// 暂存提交
export const sBillUpdate = p => post(`/${name}/sBill/update`, p)
// 货源退回 推送
export const KCBupdateStatus = p => post(`/${name}/kCustomerBill/updateStatus`, p)
// 紧急度
export const KCBupdate = p => post(`/${name}/kCustomerBill/update`, p)
// 指派
export const confirmIdentify = p => post(`/${name}/kCustomerBill/confirmIdentify`, p)
// 查看报价
export const KSOlist = p => post(`/${name}/kShipmentOffer/list `, p)

// 折线图
export const dateWeightByUserId = p => post(`/${name}/kCustomerBill/dateWeightByUserId`, p)
// 饼状图
export const statusCountByUserId = p => post(`/${name}/kCustomerBill/statusCountByUserId`, p)
// 柱状图
export const shipmentWeightCountByUserId = p => post(`/${name}/kCustomerBill/shipmentWeightCountByUserId`, p)
// 首页数据
export const companyCount = p => post(`/${name}/kCustomerBill/companyCount`, p)

// 平台端 投诉处理接口
export const afterSaleList = p => post(`/${orderName}/sWayAfterSales/list`, p)
// 平台端 退回
export const afterSaleFeedback = p => post(`/${orderName}/sWayAfterSales/feedback`, p)
export const afterSaleAcceptance = p => post(`/${orderName}/sWayAfterSales/acceptance`, p)
export const afterSaleSaveAcceptance = p => post(`/${orderName}/sWayAfterSales/saveAcceptance`, p)
// 根据订单查询运单
export const getWayListByOrderNo = p => post(`/${orderName}/way/getListWayByOrderNo`, p)

// 订单列表
export const orderList = p => post(`/${orderName}/sOrder/list`, p)
// 通过退回
export const auditOrder = p => post(`/${orderName}/sOrder/auditOrder`, p)
// 议价
export const discussOrder = p => post(`/${orderName}/sOrder/discussOrder`, p)
// 查看报价
export const sOrderOfferList = p => post(`/${orderName}/sOrderOffer/priceList`, p)
// 查看报价的指派
export const appointOrder = p => post(`/${orderName}/sOrderOffer/appointOrder`, p)
// 指派司机
export const orderAssignDriver = p => post(`/${orderName}/sOrder/orderAssignDriver`, p)
// 车队指派
export const orderAssignFleet = p => post(`${orderName}/sOrder/orderAssignFleet`, p)
// 抢单
export const publish = p => post(`/${orderName}/way/publish`, p)
// 运单列表
export const getListWayByOrderId = p => post(`/${orderName}/way/getListWayByOrderId`, p)
// 查看凭证
export const wayListImgs = p => post(`/${orderName}/sWayFile/listImgs`, p)
// 平台验收
export const wayAcceptance = p => post(`/${orderName}/way/acceptance`, p)
// 货主签收
export const waySignForWay = p => post(`/${orderName}/way/signForWay`, p)
// 运单评价
export const evaluateAdd = p => post(`/${orderName}/evaluate/add`, p)
// 申请售后
export const sWayAfterSalesAdd = p => post(`/${orderName}/sWayAfterSales/add`, p)
// 运单详情
export const wayDetail = p => post(`/${orderName}/way/getbusinessNo`, p)
// 运单列表
export const wayList = p => post(`/${orderName}/way/list`, p)
// 获取平台电话
export const findDictByCode = p => post(`/${orderName}/sDict/findDictByCode`, p)
// 合同
export const getContractPdfForBusinessNo = p => post(`/${contractName}/api/contractSignature/getContractPdfForBusinessNo`, p)
// 车队长运单管理
export const captainList = p => post(`/${orderName}/way/captainList`, p)
// 车队拒绝/平台撤销车队
export const refuseOrder = p => post(`/${orderName}/sOrder/refuseOrder`, p)
// 撤回指派给司机得订单
export const orderAssignDriverCancel = p => post(`/${orderName}/sOrder/orderAssignDriverCancel`, p)
// 运单撤回
export const wayGrabbingCancel = p => post(`/${orderName}/way/wayGrabbingCancel`, p)
// 运单指派司机
export const orderGrabbingAssignDriver = p => post(`/${orderName}/way/orderGrabbingAssignDriver`, p)
// 平台退回
export const returnOrder = p => post(`/${orderName}/sOrder/returnOrder`, p)
// 获取客户服务费率
export const findSMPRate = p => post(`/${orderName}/sOrder/findSMPRate`, p)
// 补单
export const supplementOrder = p => post(`/${orderName}/sOrder/supplementOrder`, p)
// 撤回
export const wayRecall = p => post(`/${orderName}/way/recall`, p)
// 换车
export const changeCarLog = p => post(`/${orderName}/changeCarLog/add`, p)
// 运单编辑
export const wayUpdate = p => post(`/${orderName}/way/update`, p)
// 运单删除
export const deleteWay = p => post(`/${orderName}/way/deleteWay`, p)
// 冻结明细
export const freezeDetail = p => post(`/${orderName}/sOrder/freezeDetail`, p)
// 结算明细
export const settlementDetail = p => post(`${payServer}/downstreamSettlement/settlementDetail`, p)
// 货主得支付明细
export const upSettlementDetail = p => post(`${payServer}/upstreamSettlement/upSettlementDetail`, p)
// 平台端运单图片加标识
export const updateImageType = p => post(`${orderName}/sWayFile/updateImageType`, p)
// 平台端运单图片删除
export const sWayFileDel = p => post(`${orderName}/sWayFile/delete`, p)
// 货主端运单管理支付明细
export const socUpSettlementDetail = p => post(`${payServer}/downstreamSettlement/socUpSettlementDetail`, p)
// 撤单记录
export const cancelList = p => post(`/${orderName}/sCancelRecords/list`, p)
// 运单上传凭证
export const insertWayListFile = p => post(`/${orderName}/way/insertWayListFile`, p)
// 审核运单详情
export const getWayByWayNo = p => post(`/${orderName}/api/getWayByWayNo`, p)
// 审核运单
export const auditRecordsWay = p => post(`/${orderName}/auditRecords/update`, p)
// 更新运单轨迹
export const updateWayTrajectory = p => post(`/${orderName}/way/updateWayTrajectory`, p)
// 运单审核记录
export const auditRecordsList = p => post(`/${orderName}/auditRecords/list`, p)
// 订单管理-删除
export const RecallOrderOrWay = p => post(`/${orderName}/sOrder/recallOrderOrWay`, p)

// ---------------报表统计--------------------
export const productNameList = p => post(`/${orderName}/api/order/productNameList`, p)// 平台运价统计-货物分类
export const getTrafficCountNoGroup = p => post(`/${orderName}/api/order/getTrafficCountNoGroup`, p)// 平台运价统计-数据统计
export const productWeightList = p => post(`/${orderName}/api/order/productWeightList`, p)// 平台运价统计-重量分类
export const getTrafficCount = p => post(`/${orderName}/api/order/getTrafficCount`, p)// 平台运价统计-12月波动折线图
export const getPriceCount = p => post(`/${orderName}/api/order/getPriceCount`, p)// 平台运价统计-运价统计
export const transportationInfo = p => post(`/${orderName}/api/order/transportationInfo`, p)// 运输报表
// ---------------找车接口--------------------
export const isExceptionOrTrigger = p => post(`/${orderName}/sDemand/isExceptionOrTrigger`, p)// 平台订单监控-异常(常)
export const monitorBidingSDemandList = p => post(`/${orderName}/admin/transactionCenter/monitorBidingSDemandList`, p)// 平台竞价监控(梁)
export const monitorSeckillSDemandList = p => post(`/${orderName}/admin/transactionCenter/monitorSeckillSDemandList`, p)// 平台抢单监控(梁)
export const selectTenantListFromCustomer = p => post(`${crmServer3}/sTenant/selectTenantListFromCustomer`, p)// 车队报表委托方(平)
export const sTenantUserBindingRelList = p => post(`${crmServer3}/sTenantUserBindingRel/list`, p)// 车队报表承运方(平)
export const orderTenantList = p => post(`/${orderName}/sOrder/orderTenantList`, p)// 收入明细-委托方(平)
export const orderCarriageList = p => post(`/${orderName}/sOrder/orderCarriageList`, p)// 收入明细-委托方(平)
export const upstreamSettlementList = p => post(`${payServer}/upstreamSettlement/list`, p)// 收入明细-委托方(平)
export const showBiddingResult = p => post(`/${orderName}/sDemandOffer/showBiddingResult`, p)// 查看结果(梁)
export const dictionaryList = p => post(`/${orderName}/dictionary/list`, p)// 发布货源付款客户下拉框（平）
export const evaluateList = p => post(`/${orderName}/evaluate/list`, p)// 货主查看评价功能（平）
export const updateReceiveInfo = p => post(`${orderName}/sOrder/updateReceiveInfo`, p)// 货主订单管理修改付款客户，收款金额(平)
